<template>
  <div>
    <div class="dldeing">
      <img src="../../assets/img/logo.png" width="20%"/>
    </div>
    <div class="pin">
      <van-field type="tel" v-model="value" placeholder="请输入手机号" />
      <van-field
        type="password"
        v-model="value1"
        placeholder="请输入密码"
        style="margin-top: 10px"
      />
      <van-field disabled style="display: none" />
      <span class="waspan" @click="wang">忘记密码？</span>
      <div class="dlanniu" @click="login">登 录</div>
    </div>
  </div>
</template>
<script>
import { login,usercenterinfo,siteurl } from "@/api/home";
import { Toast } from "vant";
import { Dialog } from 'vant';
export default {
  data() {
    return {
      value: "",
      value1: "",
      path:'',
      isSettingPwdQuestion:''
    };
  },
  watch: {},
  components: {},
  methods: {
    login() {
      let that = this;
      if (this.value == "") {
        Toast("请输入手机号！");
        return false;
      }
      if (this.value1 == "") {
        Toast("请输入密码！");
        return false;
      }
      // if (!/^1[23456789]\d{9}$/.test(this.value)) {
      //   Toast("请输入正确手机号！");
      //   return false;
      // }
      let params = {
        roleType: "teacher",
        account: that.value,
        password: that.value1,
        appId: 'wx29b2bf8c2c033c0d',
        code:this.getQueryString('code')
      };
      login(params)
        .then((res) => {
          if(res.data.code=='1000068'){
            Dialog.alert({
              title: '提示',
              message: 'code失效，请重新登录！',
            }).then(() => {
              let local=siteurl+"#/log"
              window.location.href=local
            });
          }else{
            localStorage.setItem("token", res.data.data.token);
            that.isSettingPwdQuestion=res.data.data.isSettingPwdQuestion
            that.usercenterinfo();
          }
        })
        .catch(() => {});
    },
    usercenterinfo() {
      let that = this;
      usercenterinfo()
        .then((res) => {
          localStorage.setItem("headPhotoUrl", res.data.data.teacher.headPhotoUrl);
          localStorage.setItem("name", res.data.data.teacher.name);
          localStorage.setItem("schoolName", res.data.data.teacher.schoolName);
          localStorage.setItem("userId", res.data.data.userId);
          localStorage.setItem("roleType", res.data.data.roleType);
          localStorage.setItem("schoolId", res.data.data.schoolId);
          localStorage.setItem("groupId", res.data.data.groupId);
          // if(that.isSettingPwdQuestion=0){
          //   that.$router.push({
          //     path: "/security",
          //   });
          //   return false
          // }
          if(that.path=='/newpassword'){
            that.$router.push({
              path: "/index",
            });
          }else{
            if(this.$route.query.id){
              let local=siteurl+"#/indexvideo?id="+this.$route.query.id
              window.location.href=local
            }else{
              let local=siteurl+"#/myindex"
              window.location.href=local
            }
          }
        })
        .catch(() => {});
    },
    wang(){
      this.$router.push({
        path: "/forget",
      });
    },
    getCode() {
      // 非静默授权，第一次有弹框
      let code = this.getQueryString('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      // code='091grf000i8UBL1TGH300vl0Hz1grf0C'
      const local = window.location.href;
      if (code == null || code === "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri="+ encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"
      } 
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.path=from.path
    })
    },
  mounted() {
    this.getCode()
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/my/log.vue